import { useLocation } from 'react-router';
import en from './../../lang/en.json';
import es from './../../lang/es.json';
import jp from './../../lang/jp.json';

const useLanguage = () => {
  const languageQuery = new URLSearchParams(useLocation().search).get(
    'language'
  );

  if (languageQuery?.startsWith('jp') || languageQuery?.startsWith('ja')) {
    return { language: 'jp', translations: jp, locale: 'ja-JP' };
  } else if (languageQuery?.startsWith('es')) {
    return { language: 'es', translations: es, locale: 'es-ES' };
  } else {
    return { language: 'en', translations: en, locale: 'en-US' };
  }
};

export default useLanguage;
